// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesSort-cls1_osa","cls2":"ArticlesSort-cls2_pvs ArticlesSort-cls1_osa"};